import { UseQueryOptions } from '@tanstack/react-query';
import participantsApi from '@/features/dashboard/participants/api/participantsApi.ts';
import { participantsApiQueryKeys } from '@/features/dashboard/participants/api/participantsApi.queryKeys.ts';
import { ParticipantDetailsDto } from '@/features/dashboard/participants/types/ParticipantDetailsDto.ts';

export const getParticipantDetailsQueryOptions = (
  participantId: string,
): UseQueryOptions<ParticipantDetailsDto> => ({
  queryKey: participantsApiQueryKeys.details(participantId),
  queryFn: () => participantsApi.getParticipantDetails(participantId),
  enabled: participantId !== undefined,
});
